import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { beautyBaseUrl } from "network";

export const locationSlice = createApi({
    reducerPath: "locationSlice",
    baseQuery: fetchBaseQuery({
        baseUrl: beautyBaseUrl,
        credentials: "include",
        prepareHeaders: (headers, { getState }) => {
            const state = getState();
            const token = state.auth?.token;
            if (token) {
                console.log('token', token);
                headers.set("authorization", `Bearer ${token}`);
            } else {
                console.warn("Token not found in state.auth");
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getLocations: builder.query({
            query: ({ page = 1, limit = 100, search = "" }) => ({
                url: `/services?page=${page}&limit=${limit}&search=${search}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),

        // ✅ Add New Location
        addCityLocation: builder.mutation({
            query: (body) => ({
                url: "/services",
                method: "POST",
                body,
            }),
        }),

        // ✅ Add New Location
        getSingleLocation: builder.query({
            query: (id) => ({
                url: `/services/${id}`,
                method: "get",

            }),
        }),


        // ✅ Update Existing Category
        updateCityLocation: builder.mutation({
            query: ({ id, body }) => ({
                url: `/services/${id}`,
                method: "PUT",
                body,
            }),
        }),

        // ✅ Delete Category
        deleteLocation: builder.mutation({
            query: (id) => ({
                url: `/services/${id}`,
                method: "DELETE",
            }),
        }),


        getPincodes: builder.query({
            query: ({ cityName }) => ({
                url: `/services/pincodes/${cityName}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),

        checkPincode: builder.query({
            query: ({ city, pincode }) => ({
                url: `/services/pincodeDetail/${city}/${pincode}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),
    }),
});

export const {
    useGetLocationsQuery,
    useAddCityLocationMutation,
    useGetSingleLocationQuery,
    useUpdateCityLocationMutation,
    useDeleteLocationMutation,
    useLazyGetPincodesQuery,
    useLazyCheckPincodeQuery,
} = locationSlice;
